import i18next from "i18next";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import "./BoardMembers.style.css";
import { members } from "./BoardMembersList";

const ExecutiveCommitee = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const currentLang = i18next.language?.startsWith("tr") ? "tr" : "en";

  // Sadece yönetim kurulu üyeleri
  const members_exec = members.filter(m => m.classfield === "icra");

  // Modal state
  const [selected, setSelected] = useState(null);

  const openModal = (m) => {
    setSelected(m);
    document.body.style.overflow = "hidden"; // scroll kilidi
  };
  const closeModal = () => {
    setSelected(null);
    document.body.style.overflow = "";
  };

  // ESC ile kapat
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") closeModal(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  return (
    <div>
      <Meta
        title={t("executive-committee") }
        description={t("executive-committee")}
        lang={lang}
      />
      <Navbar />

      <div className="c-wrapper">
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/public-offering.jpg")}
                style={{ width: "100%" }}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div className="c-caption-section" style={{ color: "#000", textAlign: "center" }}>
                {t("investor-relations")}
              </div>
              <h1 className="c-caption-header" style={{ color: "#000" }}>
                {t("executive-committee")}
              </h1>
            </div>
          </div>
        </div>

        {/* İçerik alanı: solda sidebar, sağda grid */}
        <div className="po-container">
          <InvestorSidebar />

          <main className="board-content">
            <div className="board-grid">
              {members_exec.map((m) => (
                <button
                  key={m.id}
                  className="board-card"
                  onClick={() => openModal(m)}
                  aria-haspopup="dialog"
                  aria-label={`${m.name[currentLang]} - ${m.title[currentLang]}`}
                >
                  <div className="board-photo-wrap">
                    <img src={m.photo} alt={m.name[currentLang]} className="board-photo" />
                  </div>
                  <div className="board-name">{m.name[currentLang]}</div>
                  <div className="board-title">{m.title[currentLang]}</div>
                </button>
              ))}
            </div>
          </main>
        </div>
      </div>

      {/* Modal */}
      {selected && (
        <div
          className="board-modal-overlay"
          role="dialog"
          aria-modal="true"
          onClick={(e) => { if (e.target.classList.contains("board-modal-overlay")) closeModal(); }}
        >
          <div className="board-modal">
            <button className="board-modal-close" onClick={closeModal} aria-label={t("close") || "Kapat"}>
              ×
            </button>
            <div className="board-modal-body">
              <img src={selected.photo} alt={selected.name[currentLang]} className="board-modal-photo" />
              <h2 className="board-modal-name">{selected.name[currentLang]}</h2>
              <div className="board-modal-title">{selected.title[currentLang]}</div>
              <p className="board-modal-bio">{selected.bio[currentLang]}</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ExecutiveCommitee;
